import { createFileRoute, Outlet } from "@tanstack/react-router";

import { BillingProductFeatureGate } from "src/components/BillingProductFeatureGate";

export const Route = createFileRoute("/_auth/_coach/products")({
  component: RouteComponent,
  staticData: {
    getBreadcrumb() {
      return {
        id: "products",
        labelTranslationKey: "productsPage.title",
        href: "/products",
      };
    },
  },
});

function RouteComponent() {
  return (
    <BillingProductFeatureGate feature="sellProducts">
      <Outlet />
    </BillingProductFeatureGate>
  );
}
